export const messages = {
  en: {
    printAccountReceipt: {
      depositSlip: 'Deposit Slip',
      receiptNum: 'Receipt Number',
      depositTime: 'Deposit Time',
      number: 'No.',
      accountName: 'Account Name',
      accountType: 'Account Type',
      owner: 'Owner',
      depositAmount: 'Deposit Amount',
      depositMethod: 'Deposit Method',
      currentBalance: 'Current Balance',
      remark: 'Remark',
      chineseAmount: 'Chinese Amount',
      departmentHead: 'Department Head',
      operator: 'Operator',
      financialCollection: 'Financial Collection',
      customerConfirmation: 'Customer Confirmation',
      loadError: 'Failed to load receipt data',
      loadSpecError: 'Failed to load print specification'
    }
  },
  zh: {
    printAccountReceipt: {
      depositSlip: '预存单',
      receiptNum: '单号',
      depositTime: '预存时间',
      number: '编号',
      accountName: '账户名称',
      accountType: '账户类型',
      owner: '业主',
      depositAmount: '预存金额(元)',
      depositMethod: '预存方式',
      currentBalance: '当前余额',
      remark: '备注',
      chineseAmount: '大写人民币',
      departmentHead: '部门负责人',
      operator: '经办人',
      financialCollection: '财务收款',
      customerConfirmation: '客户确认',
      loadError: '加载收据数据失败',
      loadSpecError: '加载打印规格失败'
    }
  }
}